export default function (context, {field, value}) {
    switch (field) {
        case 'CategoryId':
            context.commit('set', {
                CategoryId: value,
                PaymentTypeId: '',
                CashId: '',
                PaymentAccountId: '',
            });
            break;
        case 'Contragent':
            let type = '';
            switch (value.type) {
                case 'client':
                    type = 5;
                    break;
                case 'partner':
                    type = 3;
                    break;
                case 'partnerLegal':
                    type = 6;
                    break;
            }
            context.commit('set', {
                ContragentID: value.value ? value.value : '',
                ContragentName: value.label ? value.label : '',
                ContragentType: type,
            });
            break;
        default:
            let d = {};
            d[field] = value;
            context.commit('set', d);
    }
}